import { Link, Typography } from "@mui/material";
import { Links } from "src/constants";
import { FeedItemDto } from "src/http";

interface IProps {
  feedItem: FeedItemDto;
}

const TeamPurposePropertyChange = (props: IProps) => {
  return (
    <Typography variant="caption" sx={{ alignItems: "center" }}>
      <Link href={Links.User(props.feedItem.user.userId)}>{props.feedItem.user.displayName}</Link>
      <span> updated purpose to </span>
      <strong>{props.feedItem.propertyChange!.value}</strong>
    </Typography>
  );
};

export { TeamPurposePropertyChange };
